<template>
    <md-dialog
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            @keydown.esc="updateIsAddingComment"
            :md-active.sync="show_add_comment">
        <md-toolbar >
            <div class="md-title md-layout md-gutter md-alignment-center-left" style="width: inherit">
                <div class="md-layout-item" style="padding-left: inherit">
                    Add Comment to Order #{{ order.porting_order_number }}
                </div>
                <div class="md-layout md-alignment-center-right">
                    <md-button class="md-primary md-layout-item md-size-10"
                               @click="updateIsAddingComment"
                               :md-ripple="false"
                               >
                        <md-icon>close</md-icon>
                    </md-button>
                </div>
            </div>
        </md-toolbar>
        <md-dialog-content>
            <form>
                <div class="md-layout" style="display: grid; padding: 5px">
                    <div class="md-layout-item">
                        <md-field>
                            <label>Comments</label>
                            <md-textarea v-model="addCommentForm.comments"></md-textarea>
                        </md-field>
                    </div>
                </div>
            </form>
        </md-dialog-content>
        <md-dialog-actions class="md-layout" style="padding-top: 10px">
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="executing_comment_add"
                    @click="updateIsAddingComment"
                    type="danger"
            >Cancel
            </el-button>
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="!isFormValid()"
                    :loading="executing_comment_add"
                    @click="addComment"
                    type="success"
            >Add
            </el-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "CommentAddModal",
        props: ['show_add_comment', 'order'],
        data() {
            return {
                addCommentForm: {
                    comments: ""
                }
            }
        },
        methods: {
            updateIsAddingComment: function () {
                this.$emit('update:show_add_comment', !this.show_add_comment)
                this.clearForm();
            },
            addComment() {
                let payload = {
                    porting_order_id: this.order.id,
                    comments: this.addCommentForm.comments
                }
                this.$store.dispatch('orders/addComment', payload)
            },
            isFormValid() {
                return this.addCommentForm.comments
            },
            clearForm() {
                this.addCommentForm.comments = ""
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                executing_comment_add: state => state.orders.executing_comment_add,
                notification: state => state.orders.notification,
            }),
        },
        watch: {
            executing_comment_add: function (newVal, oldVal) {
                if (newVal === false && oldVal === true && this.notification.type === 'success') {
                    this.updateIsAddingComment()
                    this.clearForm()
                }
            }
        },
    }
</script>

<style scoped>
    .md-dialog {
        width: 50%;
        max-width: 95%;
    }

    .md-dialog /deep/ .md-dialog-container {
        transform: none;
    }

    .md-dialog /deep/ .md-dialog-content {
        padding: 5px;
    }

    .md-list-item {
        height: 65px;
    }

    form {
        padding: 10px;
    }

    .el-input /deep/ .el-input__inner {
        border-color: gray
    }

    .el-input /deep/ .el-input__prefix {
        color: gray
    }

    .el-header, .el-footer {
        background-color: rgb(244, 244, 244);
        line-height: 60px;
        font-size: 16px;
        color: #4F4D4C
    }

    .el-main {
        padding-top: 0;
        padding-bottom: 10px;
    }

    .el-container {
        border: 1px solid #EBEEF5;
    }

    button {
        font-weight: 500;
    }

</style>